import * as React from "react";
import { IClient, IFeesCalculated } from "intake_shared/src/types";
import {
    TUpdateClient,
    TUpdateClientByStatus,
    TUpdateMultipleClientFieldsByStatus,
} from "../../../clientUiTypes";
import { Card } from "../../../../bits/Card/Card";
import InsuranceForm from "../../edit-client/InsuranceForm/InsuranceForm";
import InsuranceValues from "../../insurance/InsuranceValues/InsuranceValues";

interface FeeSettingProps {
    client: IClient;
    updateClient: TUpdateClient;
    updateClientByStatus: TUpdateClientByStatus;
    updateMultipleClientFieldsByStatus: TUpdateMultipleClientFieldsByStatus;
}

export default function FeeSetting({
    client,
    updateClient,
    updateClientByStatus,
    updateMultipleClientFieldsByStatus,
}: FeeSettingProps) {
    const [feesCalculated, setFeesCalculated] = React.useState<IFeesCalculated>();
    const [autoFillFees, setAutoFillFees] = React.useState(false);

    return (
        <>
            <Card>
                <InsuranceForm
                    client={client}
                    updateClient={updateClient}
                    updateMultipleClientFieldsByStatus={
                        updateMultipleClientFieldsByStatus
                    }
                    viewingInsuranceVerification={true}
                />
            </Card>
            <InsuranceValues
                showLicFees={true}
                client={client}
                updateClientByStatus={updateClientByStatus}
                setFeesCalculated={setFeesCalculated}
                setAutoFillFees={setAutoFillFees}
                updateClient={updateClient}
                feesCalculated={feesCalculated}
                autoFillFees={autoFillFees}
                updateMultipleClientFieldsByStatus={
                    updateMultipleClientFieldsByStatus
                }
            />
        </>
    );
}
